import { Font } from '@menu/models';

export class PrintMenuTheme {
  static configuration = null;

  constructor(guid, primaryColor, secondaryColor, accentColor, primaryFont, secondaryFont, borderStyle,
    borderWidth, borderColor, subsectionBorderStyle, subsectionBorderWidth, subsectionBorderColor) {
    this.guid = guid;
    this.primaryColor = primaryColor;
    this.secondaryColor = secondaryColor;
    this.accentColor = accentColor;
    this.primaryFont = primaryFont;
    this.secondaryFont = secondaryFont;
    this.borderStyle = borderStyle;
    this.borderWidth = borderWidth;
    this.borderColor = borderColor;
    this.subsectionBorderStyle = subsectionBorderStyle;
    this.subsectionBorderWidth = subsectionBorderWidth;
    this.subsectionBorderColor = subsectionBorderColor;
  }

  fontHeadLinks() {
    return '';
  }

  addStyles() {
    return `<style>
                @font-face {
                    font-family: ${this.primaryFont.fontFamily}; src: url(${this.primaryFont.url});
                }
                @font-face {
                    font-family: ${this.secondaryFont.fontFamily}; src: url(${this.secondaryFont.url});
                }
                @media print
                {
                    .no-print, .no-print *
                    {
                        display: none !important;
                    }
                }

                body {
                    margin: 0px;
                }

                .background-print{
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    background-color: white;
                }
                .primary-text {
                    font-family: ${this.primaryFont.fontFamily};
                }
                .secondary-text {
                    font-family: ${this.secondaryFont.fontFamily};
                    font-size: ${14 + PrintMenuTheme.configuration.fontSize}px;
                }

                .primary-accent {
                    font-family: ${this.primaryFont.fontFamily};
                    color: ${this.accentColor}
                }
                .secondary-accent {
                    font-family: ${this.secondaryFont.fontFamily};
                    color: ${this.accentColor}
                }

                .background-primary-color {
                    background-color: ${this.primaryColor}
                }
                .section-title {
                    display: inline-block;
                    color: white;
                    padding: 5px 15px;
                    margin-block: 3px;
                    margin-top: 0px;
                }
                .section-title-small {
                    font-size: 16px;
                }
                .section-title-medium {
                    font-size: 24px;
                }
                .section-title-large {
                    font-size: 26px;
                }
                .subsection-title {
                    font-family: ${this.primaryFont.fontFamily};
                    color: ${this.secondaryColor};
                    text-align: center;
                    margin-block: 6px;
                    font-size: 17px;
                    margin-left: 15px;
                    margin-right: 15px;
                }

                .description {
                    font-family: ${this.primaryFont.fontFamily};
                    margin: 4px 10px;
                    font-size: 16px;
                    line-height: 16px;
                }
                .description-bold {
                    color: black;
                    font-weight: bold;
                }
                .description-normal {
                    color: ${this.primaryColor};
                    font-weight: normal;
                }

                .products-list{
                    list-style: none;
                    font-size: 14px;
                    line-height: 22px;
                    margin: 0;
                }
                .product-list-two-columms {
                    -webkit-column-count: 2; /* para navegadores basados en Webkit */ -moz-column-count: 2; /* para navegadores basados en Gecko */
                    column-count: 2; /* para otros navegadores */
                    -webkit-column-gap: 1em; /* espaciado entre columnas */
                    -moz-column-gap: 1em;
                    column-gap: 1em;
                }
                .product-list-two-columms li{
                    break-inside: avoid-column; /* para evitar que un elemento se divida en columnas */
                }
                .product-item{
                    clear: both;
                    margin-bottom: 2px;
                    page-break-inside: avoid;
                }
                .container-header {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    margin-bottom: 10px;
                }
                .disclaimer {
                    font-size: 12px;
                }
            </style>`;
  }

  static toInstance(props = {}) {
    const primaryFont = Font.toInstance(props.primary_font);
    const secondaryFont = Font.toInstance(props.secondary_font);
    return new PrintMenuTheme(props.guid, props.primary_color, props.secondary_color,
      props.accent_color, primaryFont, secondaryFont, props.border_style, props.border_width,
      props.border_color, props.subsection_border_style, props.subsection_border_width, props.subsection_border_color);
  }
}
